import { jsx as r } from "react/jsx-runtime";
import { c as a } from "../../../index-Cu0xwYjD.js";
import { s as t } from "../../../Skeleton.module-BVp5AJxK.js";
const n = ({
  size: s = "25rem",
  className: e,
  ...o
}) => /* @__PURE__ */ r(
  "p",
  {
    "aria-hidden": "true",
    "aria-busy": "true",
    className: a(t.skeleton, t.button, e),
    style: { width: s },
    ...o
  }
);
export {
  n as SkeletonButton
};
